import { 
  CallHistoryPage, ContactList, 
  DialerOnCallPage, DialerPage, 
  IncomingCallPage, LoginPage, 
  OngoingCallPage, OutgoingCallPage 
} from "../pages";

export default {
  LoginPage: {
    path: '/',
    page: <LoginPage />,
  },
  ContactList: {
    path: '/contacts',
    page: <ContactList />,
  },
  DialerPage: {
    path: '/dialer',
    page: <DialerPage />,
  },
  DialerOnCallPage: {
    path: '/dialerCall',
    page: <DialerOnCallPage />,
  },
  OngoingCallPage: {
    path: '/call',
    page: <OngoingCallPage />,
  },
  OutgoingCallPage: {
    path: '/dialing',
    page: <OutgoingCallPage />,
  },
  IncomingCallPage: {
    path: '/callReceived',
    page: <IncomingCallPage />,
  },
  CallHistoryPage: {
    path: '/callHistory',
    page: <CallHistoryPage />,
  },
}
